var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basicSearch',_vm._g(_vm._b({attrs:{"onSearchApi":_vm.onSearchApi,"placeholder":"搜索赛事"}},'basicSearch',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }